module.exports = __webpack_public_path__ + "static/media/barbell.8782e3ed.webp";